// Requisitos gerais de sistema do jogo (Godot 4.7, Forward+). Dados neutros em game-requirements.json; os
// textos por plataforma estão em i18n (chaves dl.req.*). Racional e como atualizar: docs/legais-e-requisitos.md.
import requirements from "./game-requirements.json" with { type: "json" };

export type GameRequirements = { network: { online: boolean } };

export const GAME_REQUIREMENTS = requirements as unknown as GameRequirements;
